export default "../css/3baf08746db7adc176188c170d4390bb.ttf";